export default __webpack_public_path__ + "static/media/AvenirLTStd-Black.7ce894e1.otf";